import React from "react";
import { Badge } from "reactstrap";
import Img from "../Img";
import artistString from "../../utils/artistString";

const Track = props => {
  const { data, actions } = props;
  if (!data) return null;
  return (
    <div className="d-flex align-items-center flex-grow-1">
      <div className="ml-3">
        <Img fill="#ccc" src={data.image ? `${data.image.replace('http://', '//').replace('https://', '//')}` : null} width="40" height="40" className="rounded" />
      </div>
      <div className="ml-3">
        <h6 className="mb-0">
          {data.name}
        </h6>
        <small>
          {artistString(data.artists)}
        </small>
      </div>

      <Badge className="ml-1">
        {data.durationMin}:{data.durationSec}
      </Badge>
      {data.aacPath && (
        <Badge className="ml-1" color="primary">
          aac
        </Badge>
      )}
      {data.oggPath && (
        <Badge className="ml-1" color="info">
          ogg
        </Badge>
      )}
      {actions &&
        <div className="mr-auto">
          {actions}
        </div>
      }
    </div>
  )
}

export default Track;